import { render, staticRenderFns } from "./PlacementDetails.vue?vue&type=template&id=021c5654&"
import script from "./PlacementDetails.vue?vue&type=script&lang=js&"
export * from "./PlacementDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports